import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { showAlert } from 'lib/functions/utils';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { createDocumentsFromCompany } from '../../../../../../../../lib/api';
import CustomButton from '../../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../../lib/designSystem/CircularProgress';
import HeaderWithActions from '../../../../../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../../../../../lib/designSystem/Table';
import AddInvoicesCSV from './csvParse';
import AddInvoicesForm from './invoicesForm';

const AddInvoicesManually = (props: any) => {
  const {
    open,
    setOpen,
    business,
    subProductSelected,
    handleSearchSuggestedDocuments,
    setSuccessOpen,
    isEnrolled,
    onDocumentsCreated,
  } = props;
  const dispatch = useDispatch();
  const [inputType, setInputType] = useState<string | null>(null);
  const [invoices, setInvoices] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const uploadInvoices = async () => {
    setLoading(true);
    try {
      const formatInvoicesWithDate = invoices.map((invoice) => {
        const formatted: any = {
          ...invoice,
          issuedDate: new Date(invoice.issuedDate).toISOString(),
          amount: parseFloat(invoice.amount),
        };
        if (invoice.dueDate) {
          formatted.dueDate = new Date(invoice.dueDate).toISOString();
        }
        return formatted;
      });
      const response = await createDocumentsFromCompany(dispatch, {
        documents: formatInvoicesWithDate,
        businessIdentifier: business.identifier,
        subProductId: subProductSelected,
      });
      const createdDocuments = response?.documentCreated || [];
      const repeatedDocuments = response?.documentsRepetead || [];
      setSuccessOpen('Facturas agregadas correctamente.');
      setOpen(false);

      if (
        onDocumentsCreated &&
        (createdDocuments.length > 0 || repeatedDocuments.length > 0)
      ) {
        await onDocumentsCreated(
          { created: createdDocuments, repeated: repeatedDocuments },
          invoices.length,
        );
      } else {
        await handleSearchSuggestedDocuments({
          page: 0,
          pageSize: 10,
          subProductOverride: subProductSelected,
        });
      }
    } catch (error) {
      console.error(error);
      showAlert(
        dispatch,
        'error',
        'Error al agregar facturas. Revisa los datos ingresados.',
      );
    }
    setLoading(false);
  };

  return (
    <div>
      <Dialog maxWidth="md" open={open}>
        <DialogTitle>
          <HeaderWithActions title="Agregar facturas" type="dialogHeader" />
        </DialogTitle>
        {loading ? (
          <CenteredCircularProgress type="dialog" />
        ) : (
          <DialogContent>
            {!inputType ? (
              <div>
                <Typography variant="body1">
                  Acá podrás agregar facturas de manera manual. Puedes hacerlo
                  ingresando las facturas o ingresando el formato de xlsx con
                  las facturas.
                </Typography>
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                      width: '80%',
                      padding: 30,
                      margin: 'auto',
                    }}
                  >
                    <CustomButton
                      color="primary"
                      onClick={() => {
                        setInputType('manual');
                      }}
                    >
                      Manual
                    </CustomButton>
                    <CustomButton
                      color="primary"
                      onClick={() => {
                        setInputType('sii');
                      }}
                    >
                      XLSX
                    </CustomButton>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                {inputType === 'manual' ? (
                  <AddInvoicesForm
                    setInvoices={setInvoices}
                    invoices={invoices}
                    business={business}
                    isEnrolled={isEnrolled}
                  />
                ) : (
                  <AddInvoicesCSV
                    setInvoices={setInvoices}
                    invoices={invoices}
                    business={business}
                    isEnrolled={isEnrolled}
                  />
                )}
              </div>
            )}
            <div>
              {invoices.length > 0 && (
                <div>
                  <Typography variant="body1">Facturas verificadas:</Typography>
                  <div>
                    <EnhancedTable
                      dataHeaders={[
                        { key: 'folio', label: 'Folio' },
                        { key: 'stakeholderIdentifier', label: 'Rut deudor' },
                        { key: 'stakeholderName', label: 'Nombre deudor' },
                        {
                          key: 'issuedDate',
                          label: 'Fecha emisión',
                          type: 'eight-days-date',
                        },
                        { key: 'amount', label: 'Monto', type: 'money' },
                      ]}
                      data={invoices}
                      finalSumRow
                    />
                  </div>
                </div>
              )}
            </div>
          </DialogContent>
        )}
        <DialogActions>
          {invoices.length && !loading ? (
            <CustomButton color="primary" onClick={() => uploadInvoices()}>
              Guardar
            </CustomButton>
          ) : null}
          <CustomButton
            onClick={() =>
              inputType && invoices.length ? setInputType(null) : setOpen(false)
            }
            color="secondary"
          >
            Volver
          </CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddInvoicesManually;
